import {throwError as observableThrowError,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient ,HttpErrorResponse,HttpHeaders} from '@angular/common/http';
import 'rxjs/Rx'; // importing RxJs operators like map
import { API_URLS } from '../utils/api_url.util';
import { HelpTopicModel } from '../model/help_topic.model';

@Injectable({
  providedIn: 'root'
})
export class HelpTopicService {

  mItem:HelpTopicModel;
 
  constructor(private http: HttpClient) {
  
  }

   getItems(): Observable<Array<HelpTopicModel>>{
    let items$ = this.http
      .get<Array<HelpTopicModel>>(API_URLS.API_HELP_TOPICS).pipe(
      catchError(handleError));
      return items$;
   }


   addItem(item:HelpTopicModel): Observable<HelpTopicModel>{

    let body = JSON.stringify(item);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let items$ = this.http
      
      .post<HelpTopicModel>(API_URLS.API_HELP_TOPICS,body,options).pipe(
      catchError(handleError));
      return items$;  
    }

  
   editItem(item:HelpTopicModel): Observable<HelpTopicModel>{

    let body = JSON.stringify(item);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    let items$ = this.http 
    .put<HelpTopicModel>(API_URLS.API_HELP_TOPICS+`/${item.Id}`,body,options).pipe(
    catchError(handleError));
    return items$;

    }


    deleteItem(item:HelpTopicModel): Observable<HelpTopicModel>{

      let body = JSON.stringify(item);
      let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      let options = { headers: headers };
      
      let items$ = this.http 
      .delete<HelpTopicModel>(API_URLS.API_HELP_TOPICS+`/${item.Id}`,options).pipe(
      catchError(handleError));
      return items$;
  
    }
  

    


}




// this could also be a private method of the component class
function handleError (error: HttpErrorResponse) {
  // log error
  // could be something more sofisticated
  console.error(error);

  return observableThrowError(error.error);

  
 }